import { useState } from "react";
import SC from "./style";
import { Button } from "InnoUI/components";
import theme from "theme";
import BulkActionView from "InnoUI/components/BulkActionView";
import { InputField } from "components";
import { Spin } from "antd";

function DeleteComponent({
  setOpenDeleteView,
  openDeleteView,
  handleDelete = () => {},
  handleArchive = () => {},
  title = "",
  firstButtontext = "Archive",
  messageData = "Are you sure you want to Delete this Data?",
  isLoading = false,
}) {
  const [inputValue, setInputValue] = useState("");
  const isDeleteEnabled = inputValue === "DELETE";

  const handleInputChange = (_, value) => setInputValue(value);

  const resetState = () => {
    setInputValue("");
    setOpenDeleteView(false);
  };

  const handleArchiveAction = () => {
    if (isLoading) return;
    handleArchive();
    resetState();
  };

  const handleDeleteAction = async (e) => {
    e.preventDefault();
    if (isLoading) return;
    await handleDelete();
    resetState();
  };

  return (
    openDeleteView && (
      <BulkActionView
        padding="10px 15px 5px 15px"
        fontSize="13px"
        // sx={{
        //   minWidth: "550px",
        // }}
        title={title}
        openModal={openDeleteView}
        closeLoading={isLoading}
        renderBodyConditionally={() => (
          <SC.Container>
            <SC.WarningContainer>
              <SC.WarningIcon />
              <SC.WarningMessage>
                Once deleted, this data cannot be recovered.
              </SC.WarningMessage>
            </SC.WarningContainer>

            <SC.MessageDataContainer>
              <SC.MessageData>{messageData}</SC.MessageData>
            </SC.MessageDataContainer>

            {isLoading && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  padding: "10px",
                  color: theme.colors.themeColor,
                  fontSize: "13px",
                  fontWeight: 600,
                }}
              >
                <Spin size="small" />
                <span>Deleting, please wait...</span>
              </div>
            )}

            <form onSubmit={handleDeleteAction}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  margin: "10px 0",
                }}
              >
                <span style={{ fontSize: "13px", userSelect: "none" }}>
                  Type "DELETE" to confirm.
                </span>
                <InputField
                  type="text"
                  value={inputValue}
                  onChange={handleInputChange}
                  style={{ width: "50%" }}
                  disabled={isLoading}
                />
              </div>

              <SC.ButtonContiner>
                <Button
                  caption={firstButtontext}
                  onClick={handleArchiveAction}
                  fontSize="12px"
                  style={{
                    marginBottom: 8,
                    background: theme.colors.cancelButton,
                    color: theme.colors.white,
                    minWidth: "90px",
                    borderRadius: "3px",
                    height: "30px",
                  }}
                  disabled={isLoading}
                />
                <Button
                  caption={isLoading ? "Deleting..." : "Delete"}
                  type="submit"
                  fontSize="12px"
                  color="white"
                  style={{
                    marginBottom: 8,
                    background: isDeleteEnabled ? "#f05455" : "#d3d3d3",
                    color: theme.colors.white,
                    minWidth: "90px",
                    borderRadius: "3px",
                    height: "30px",
                    cursor:
                      isDeleteEnabled && !isLoading ? "pointer" : "not-allowed",
                  }}
                  disabled={!isDeleteEnabled || isLoading}
                />
              </SC.ButtonContiner>
            </form>
          </SC.Container>
        )}
        handleCloseModal={isLoading ? () => {} : resetState}
      />
    )
  );
}

export default DeleteComponent;
